<template>
  <div class="program" style="height: 100%" v-wechat-title="$route.meta.title = title()">
    <van-tabs v-model="activeName" color="#006EFF" @change="onChange">
      <van-tab name="a" :title="$t('append_field.program')">
        <programList></programList>
      </van-tab>
<!--      <van-tab name="b" :title="$t('append_field.task')">
        <taskList @itemName="itemName" @changeItemShow="changeItemShow"></taskList>
      </van-tab>-->
      <van-tab name="c" :title="$t('append_field.progress')">
        <taskProgress></taskProgress>
      </van-tab>
    </van-tabs>
  </div>
</template>

<script>
import programList from '../components/programList'
import taskProgress from '../components/taskProgress'


export default {
  name: 'Programs',
  data() {
    return {
      activeName: 'a',
    }
  },
  mounted() {
    document.title = this.$t('append_field.program_management')
    this.activeName = this.$route.query.itemName
  },
  components: {
    programList,
    taskProgress
  },
  methods: {
    itemName(res) {
      this.activeName = res
    },
    onChange(event) {
      this.activeName = event;
    },
    changeItemShow(data) {
      this.activeName = data
    },
    title() {
      switch (this.activeName) {
        case 'a':
          return this.$t('append_field.program')
        case 'b':
          return this.$t('append_field.task')
        case 'c':
          return this.$t('append_field.progress')
      }
    }
  }
}
</script>

<style lang="scss">
.program{
  .van-tab__text--ellipsis{
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 20px !important;
  }
}
.van-tabs {
  height: 100%;
}

.van-tabs__wrap{
  height: 46px;
}
.van-tabs__content {
  height: calc(100% - 46px);

  .van-tab__pane {
    height: 100%;

    .programList {
      height: 100%;

      .content {
        height: calc(100% - 40px - 20px - 55px);
      }
    }
  }
}

</style>
